import { all, fork, put, takeEvery, select } from 'redux-saga/effects';
import axios from 'axios';
import {
    SIGNUP_ORGANIZATION,
    GET_ORGANIZATION,
    UPLOAD_IMAGE,
    GET_IMAGE
} from '../actions';

import {
    signupOrganizationSuccess,
    signupOrganizationError,
    getOrganizationSuccess,
    getOrganizationError,
    uploadImageSuccess,
    uploadImageError,
    getImageSuccess,
    getImageError
} from './actions';

import {
    baseURL
} from "../../constants/defaultValues";

const getToken = state => state.auth.user && state.auth.user.token ? state.auth.user.token : undefined;

/* Signup Flow */
export function* watchSignupOrganization() {
    yield takeEvery(SIGNUP_ORGANIZATION, signupOrganization);
}

function* signupOrganization({ payload }) {
    const { name,addressStreet,addressLandmark,addressLocality,addressRegion,addressCountry,addressPostalCode,lat,lng } = payload.organization;
    // Prepare API Request Data
    const data = {
        name,
        addressStreet,
        addressLandmark,
        addressLocality,
        addressRegion,
        addressCountry,
        addressPostalCode,
        lat,
        lng
    };

    // Remove Empty Optional Fields
    if(!addressLandmark){
        delete data.addressLandmark;
    }
    if (addressCountry === 'United States') { // calculate lat & lng based on the address in API - only for country US
      delete data.lat;
      delete data.lng;
    }
    const token = yield select(getToken);
    const headers = {
        headers: { Authorization: `${token}` }
    };
    try {
        const response = yield axios.post(`${baseURL}/organizations`,data,headers);
        if (response && response.data && response.data._id) {
            localStorage.setItem('organization_id', response.data._id);
            localStorage.setItem('organization_name', response.data.name);
            yield put(signupOrganizationSuccess(response.data));
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Setting up Organization, Please verify Organization data";
            yield put(signupOrganizationError(message));
        }

    } catch (error) {
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message :
        "Error Setting up Organization, Please verify Organization data";
        yield put(signupOrganizationError(message));
    }
}

/* Signup Flow */
export function* watchGetOrganization() {
    yield takeEvery(GET_ORGANIZATION, getOrganization);
}

function* getOrganization() {
    const token = yield select(getToken);
    const headers = {
        headers: { Authorization: `${token}` }
    };
    try {
        const response = yield axios.get(`${baseURL}/organizations`,headers);
        if (response && response.data && response.data._id) {
            localStorage.setItem('organization_id', response.data._id);
            localStorage.setItem('organization_name', response.data.name);
            yield put(getOrganizationSuccess(response.data));
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Getting Organization";
            yield put(getOrganizationError(message));
        }
    } catch (error) {
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message :
        "Error Getting Organization";
        yield put(getOrganizationError(message));
    }
}


/* Upload Image */
export function* watchUploadImage() {
    yield takeEvery(UPLOAD_IMAGE, uploadImageToS3);
}

function* uploadImageToS3({payload}) {
    const { image } = payload;
    const token = yield select(getToken);
    const headers = {
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'multipart/form-data'
        }
    };

    console.log(image);

    // Form Data
    const formData = new FormData();
    formData.append("file", image, image.name);
    try {
        const response = yield axios.post(`${baseURL}/images/tag/logo`,formData,headers);
        if (response && response.data && response.data.file) {
            yield put(uploadImageSuccess(response.data));
            // Get Latest Image
            getImageFromS3();
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Getting Organization";
            yield put(uploadImageError(message));
        }
    } catch (error) {
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message :
        "Error Getting Organization";
        yield put(uploadImageError(message));
    }
}

/* Get Image */
export function* watchGetImage() {
    yield takeEvery(GET_IMAGE, getImageFromS3);
}

function* getImageFromS3() {
    const token = yield select(getToken);
    const headers = {
        headers: { Authorization: `${token}` },
        responseType: 'arraybuffer'
    };

    try {
        const response = yield axios.get(`${baseURL}/images/tag/logo`,headers);
        if (response && response.data) {
            const image = Buffer.from(response.data, 'binary').toString('base64');
            yield put(getImageSuccess(image));
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Getting Tag Logo";
            yield put(getImageError(message));
        }
    } catch (error) {
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message :
        "Error Getting Tag Logo";
        yield put(getImageError(message));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchSignupOrganization),
        fork(watchGetOrganization),
        fork(watchUploadImage),
        fork(watchGetImage),
    ]);
}
